import React, { useEffect, useContext, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthContext from "../../Context/AuthContext";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faLanguage } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Breadcrumbs from "../../Navigation/Components/Breadcrumbs";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./EditTrainingGroupForm.css";

function EditTrainingGroupForm() {
  const [name, setName] = useState("");
  const [name_english, setNameEnglish] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [english, setEnglish] = useState(false);

  const { state } = useContext(AuthContext);

  let { tid } = useParams();

  const { t } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingGroups/${tid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setName(response.data.trainingGroup.name);
      setNameEnglish(response.data.trainingGroup.name_english);
      if (state.language === "en") {
        setEnglish(true);
      } else {
        setEnglish(false);
      }
      setIsLoading(false);
    }
    fetch();
  }, [state.language, state.token, tid]);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleNameEnglishChange = (e) => {
    setNameEnglish(e.target.value);
  };

  const activateEnglish = () => {
    setEnglish(true);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingGroups/${tid}`,
        data: {
          name: name,
          name_english: name_english,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/trainings/training-groups");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  let breadcrumbs = [
    {
      title: state.language === "es" ? "Capacitaciones" : "Trainings",
      path: "/trainings",
    },
    {
      title:
        state.language === "es"
          ? "Grupos de capacitaciones"
          : "Training Groups",
      path: "/trainings/training-groups",
    },
  ];

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Breadcrumbs data={breadcrumbs} />
        </Row>
        <Row>
          <Col lg={11} className="edit-training-header">
            <h2>{t("Capacitaciones.GruposDeCapacitacion.EditForm.Titulo")}</h2>
          </Col>
          <Col lg={1} className="new-scale-header mb-2">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={activateEnglish}>
                  <FontAwesomeIcon icon={faLanguage} /> English
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          <Col className="edit-training-form">
            <Form onSubmit={handleSubmit}>
              <FloatingLabel
                controlId="floatingInput"
                label="Nombre del grupo"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="nombre del grupo"
                  onChange={handleNameChange}
                  value={name}
                />
              </FloatingLabel>
              {english ? (
                <FloatingLabel label="Training group title" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Training group title"
                    onChange={handleNameEnglishChange}
                    value={name_english}
                  />
                </FloatingLabel>
              ) : (
                <></>
              )}
              <Button className="primary" onClick={handleSubmit}>
                {t("Capacitaciones.GruposDeCapacitacion.EditForm.Guardar")}
              </Button>
              <Link to="/trainings/training-groups">
                <Button className="danger">
                  {t("Capacitaciones.GruposDeCapacitacion.EditForm.Cancelar")}
                </Button>
              </Link>
            </Form>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default EditTrainingGroupForm;
